import {Picture} from "../../../model/picture";
export class WallPicture {

    picture: Picture = new Picture();

    isNew: boolean = false;

    constructor(picture: Picture) {
        this.picture = picture;
    }

    changeWidth(width: number) {
        let that = this;

        setTimeout(function() {
            that.picture.width = width;
        }, 10);
    }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/components/event/diaporama/wall-picture.ts